export enum InventoryType {
  Brand = 'brand',
  Category = 'category',
}
